var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
        {
            veil: !_vm.isAiModal,
            'is-ai-modal': _vm.isAiModal,
        },
    ]},[_c('div',{staticClass:"underlay"}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner"},[_c('div',{staticClass:"dot1"}),_c('div',{staticClass:"dot2"})])
}]

export { render, staticRenderFns }